import request from '@/utils/request';
import { BASE_API } from '@/utils/consts'

export function getScaleAnswerRecord(data) {
  return request(`${BASE_API}/scale/getLog/${data.logId}/${data.orderId}/${data.orderItemId}/${data.custId}`);
}

// 获取量表记录
export function queryTaskScales(reservationItemId) {
  return request(`${BASE_API}/scale_log/get_scale_reservation_result/${reservationItemId}`);
}

// 获取单个量表填写记录
export function getScaleResult(taskId) {
  return request(`${BASE_API}/scale_log/getLog/${taskId}`)
}

// 编辑量表结果
export function saveScaleResult({ taskCode, ...data }) {
  return request(`${BASE_API}/scale/answer/${taskCode}`, {
    method: 'POST',
    data: [...data.newScaleAnswerReqList]
  })
}

// 发送量表填写短信
export function sendScaleMsg(data) {
  return request(`${BASE_API}/scale_log/sendNotice`, {
    method: 'POST',
    data
  })
}

// 根据量表填写记录Id（scaleLogId）修改量表结果中的评语和建议
export function putScaleResult(data) {
  return request(`${BASE_API}/scale_log/update_log`, {
    method: 'PUT',
    data
  })
}